import { createMutationHook } from '~/shared/providers/api';

export const useDeleteFacilityMutation = createMutationHook(
  'facilities.facilityDelete',
  (params: { id: string }) => ({
    coreFacilityDelete: {
      __args: {
        id: params.id,
      },
    },
  }),
);
